module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch3"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("General")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AASF")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Annales Academiae Scientiarum Fennicae")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ABR")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Australian Biblical Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ACNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Augsburg Commentaries on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ANTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Abingdon New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BCBC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Believers Church Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BDAG")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Greek–English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(", ed. W. Bauer, F. W. Danker, W. F. Arndt and F. W. Gingrich, 3rd edn (Chicago: University of Chicago Press, 2000)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BECNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BibInt")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Biblical Interpretation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BN")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblische Notizen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Black’s New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliotheca Sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bible Translator")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BTCP")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Biblical Theology for Christian Proclamation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BTNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Biblical Theology of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CBC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Cambridge Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CBET")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Contributions to Biblical Exegesis and Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Concordia Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Concordia Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CSC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Christian Standard Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ECC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Eerdmans Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ECL")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Early Christianity and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exegetical Dictionary of the New Testament")]), _vm._v(", ed. H. Balz and G. Schneider, 3 vols. (Grand Rapids: Eerdmans, 1990–3)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("EKK")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Evangelisch-katholischer Kommentar zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ExpTim")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("FRLANT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Forshungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HBT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Horizons in Biblical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("HNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Harper’s New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("HTA")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Historisch Theologische Auslegung")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("IVPNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("InterVarsity New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSPL")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Study of Paul and His Letters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTI")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Theological Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("KEK")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Kritisch-exegetischer Kommentar über das Neue Testament (Meyer-Kommentar)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LSJ")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Greek–English Lexicon")]), _vm._v(", ed. H. G. Liddell, R. Scott and H. S. Jones, 9th edn, with rev. supplement by P. G. W. Glare (Oxford: Oxford University Press, 1996)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("LXX")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Septuagint (Greek translation of the Hebrew Scriptures)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("MM")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vocabulary of the Greek Testament Illustrated from the Papyri and Other Non-Literary Sources")]), _vm._v(", ed. J. H. Moulton and G. Milligan (Grand Rapids: Eerdmans, 1930–82)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("MNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Moffat New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NCBC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New Century Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NCCS")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New Covenant Commentary Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Neot")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Neotestamentica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NIGTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New International Greek Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NovTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Supplements to Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NRTh")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nouvelle revue théologique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NSBT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("OTP")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Testament Pseudepigrapha")]), _vm._v(", ed. J. H. Charlesworth, 2 vols. (New York: Doubleday, 1983, 1985)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("PNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Pillar New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RevExp")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Review and Expositor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SBJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Southern Baptist Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SGBC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Story of God Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SHBC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Smyth & Helwys Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SIG")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sylloge Inscriptionum Graecarum")]), _vm._v(", ed. W. Dillenberger, 4 vols., 3rd edn (Leipzig: Hirzel, 1915–24)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SNTSMS")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Society of New Testament Studies Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SNTW")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Studies of the New Testament and Its World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SP")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Sacra Pagina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(", ed. G. Kittel and G. Friedrich (Grand Rapids: Eerdmans, 1964–76)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Thayer")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Greek–English Lexicon of the New Testament")]), _vm._v(", ed. J. H. Thayer (New York: American Book Company, 1889)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("THKNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Theologischer Handkommentar zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TLNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theological Lexicon of the New Testament")]), _vm._v(", ed. C. Spicq, tr. J. D. Ernest, 3 vols. (Peabody: Hendrickson, 1995)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Tyndale New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TPINTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("TPI New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TTCS")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Teach the Text Commentary Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TynBul")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("UBCS")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Understanding the Bible Commentary Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("USFISFCJ")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("University of South Florida International Studies in Formative Christianity and Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("VE")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vox Evangelica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ZECNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Zondervan Exegetical Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ancient texts")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("1 En.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("1 Enoch (Ethiopic Apocalypse)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("1QH")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Thanksgiving Hymns")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("1QM")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("War Scroll")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("1QS")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Rule of the Community, Manual of Discipline")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("2 Bar.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("2 Baruch (Syriac Apocalypse)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("2 En.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("2 Enoch (Slavonic Enoch)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("3 Bar.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("3 Baruch (Greek Apocalypse)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("4QFlor")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("4QFlorilegium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("4QMMT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Miqṣat Maʿaśê ha-Torah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Abrahamo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Acts Pet.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Acts of Peter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ag. Ap.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Josephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Against Apion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Agr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De agricultura")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Agr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Tacitus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Agricola")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ann.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Tacitus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Annales")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Josephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish Antiquities")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Apoc. Mos.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Apocalypse of Moses")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Apol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Tertullian, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apologeticus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("b. ʿAbod. Zar.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("ʿAbodah Zarah (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("b. Mak.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Makkot (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("b. Pesaḥ")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Pesaḥim (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("b. Qidd.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Qiddušin (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("b. Yebam.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Yebamot (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("b. Yoma")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Yoma (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bell. civ.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Caesar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bellum civile")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ben.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Seneca, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De beneficiis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Caus. plant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Theophrastus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De causis plantarum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Cairo Genizah copy of the Damascus Document")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Claud.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Suetonius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus Claudius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Clem.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Seneca (the Younger), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De clementia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Comm. Rom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Origen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentarii in Romanos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conf.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De confusione linguarum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Diatr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Epictetus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diatribai")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dissertationes")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Fronto, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Pliny the Younger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Seneca (the Younger), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae morales")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fug.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De fuga et inventione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Gen. Rab.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Genesis Rabbah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Geogr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Strabo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geographica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Her.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quis rerum divinarum heres sit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Tacitus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historiae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Jub.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Jubilees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("J.W.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Josephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish War")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LAB")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Liber antiquitatum biblicarum (Pseudo-Philo)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Cicero, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De legibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Legum allegoriae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leg")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Plato, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leges")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Let. Aris.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Letter of Aristeas")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Lev. Rab.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Leviticus Rabbah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. ʿAbod. Zar.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("ʿAbodah Zarah (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. ʾAbot")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("ʾAbot (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. Giṭ.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Giṭṭin (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. Ketub.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Ketubott (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. Mak.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Makkot (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. Qidd.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Qiddušin (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. Šabb.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Šabbat (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("m. Sanh.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Sanhedrin (Mishnah)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mart. Pol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Martyrdom of Polycarp")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Metam.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Apuleius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metamorphoses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Metam.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Ovid, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metamorphoses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mil. glor.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Plautus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Miles gloriosus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mor.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Plutarch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Moralia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mos.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De vita Mosis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mut.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De mutatione nominum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Odes Sol.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Odes of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Opif.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De opificio mundi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Post.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De posteritate Caini")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praem.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De praemiis et poenis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prot.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Plato, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Protagoras")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Ps.-Phoc.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Pseudo-Phocylides")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Pss Sol.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Psalms of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Quint. fratr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Cicero, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae ad Quintum fratrem")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rab. Perd.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Cicero, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pro Rabirio Perduellionis Reo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Resp.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Plato, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Respublica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Juvenal, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Satirae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Sib. Or.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Sybylline Oracles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Somn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De somniis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Spec.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" De specialibus legibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("T. Gad")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Testament of Gad")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Tg. Ps.-J.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Targum Pseudo-Jonathan")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("T. Naph.")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Testament of Naphtali")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tusc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Cicero, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tusculanae disputationes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Virt.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De virtutibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. beat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Seneca (the Younger), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De vita beata")])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bible versions")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ASV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("American Standard Version (1901).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CEB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Common English Bible. © Copyright 2011 by the Common English Bible. All rights reserved. Used by permission.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CJB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v(" The Complete Jewish Bible. Copyright © 1998 by David H. Stern. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, without prior written permission of the publisher.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CSB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v(" The Christian Standard Bible. Copyright © 2017 by Holman Bible Publishers. Used by permission. Christian Standard Bible®, and CSB® are federally registered trademarks of Holman Bible Publishers, all rights reserved.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ESV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The ESV Bible (The Holy Bible, English Standard Version), copyright © 2001 by Crossway, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("JBP")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("J.B. Phillips New Testament in Modern English")]), _vm._v(", published by HarperCollins Publishers, copyright © J. B. Phillips, 1960, 1972.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("KJV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v(" Extracts from the Authorized Version of the Bible (The King James Bible), the rights in which are vested in the Crown, are reproduced by permission of the Crown’s Patentee, Cambridge University Press.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("MSG")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("THE MESSAGE")]), _vm._v(". Copyright © by Eugene H. Peterson 1993, 1994, 1995, 1996, 2000, 2001, 2002. Used by permission of NavPress Publishing Group.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NAB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New American Bible with Revised New")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Testament and Revised Psalms")]), _vm._v(" are copyright © 1991, 1986, 1970 Confraternity of Christian Doctrine, Washington, D.C. and are used by permission of the copyright owner. All rights reserved.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NASB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The NEW AMERICAN STANDARD BIBLE®, Copyright © 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995 by The Lockman Foundation. Used by permission.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NEB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v(" The New English Bible, copyright © The Delegates of the Oxford University Press and The Syndics of Cambridge University Press, 1961, 1970. Used by permission.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NET")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The NET Bible, New English Translation, are copyright © 1996 by Biblical Studies Press, LLC. NET Bible is a registered trademark.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NIV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Holy Bible, New International Version (Anglicized edition). Copyright © 1979, 1984, 2011 by Biblica. Used by permission of Hodder & Stoughton Ltd, an Hachette UK company. All rights reserved. ‘"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("NIV")]), _vm._v("’ is a registered trademark of Biblica. UK trademark number 1448790.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NJB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Excerpts from THE NEW JERUSALEM BIBLE, copyright © 1985 by Darton, Longman & Todd, Ltd and Doubleday, a division of Penguin Random House, Inc. Reprinted by permission.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NRSV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New Revised Standard Version, Anglicized (1995).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("RSV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Revised Standard Version of the Bible, copyright © 1946, 1952 and 1971 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved. ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a3cb5ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TNTC_Romans6.vue
// module id = 72
// module chunks = 0